import { useCallback, useMemo } from 'react';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- тут нужно подумать над слоями
import { useAllBadges } from '#entities/badge';

export const useFilterTitleByValue: (values: string[]) => { value: string; title: string }[] = (values) => {
    const { data } = useAllBadges({});

    const getBadgeTitle = useCallback(
        (badgeId: string): string => data?.items.find((badge) => badge.slug === badgeId)?.label ?? badgeId,
        [data]
    );

    return useMemo(
        () =>
            values.map((value) => {
                return { value, title: getBadgeTitle(value) };
            }),
        [getBadgeTitle, values]
    );
};
